import { IdCardSignupFormValues, IdCardSubscriptionCompanyUserGroup, TransformedCompany } from "../../loginTypes"

export const transformCompanies = (companies: any[]): TransformedCompany[] => {
    const isOfficeHotelCompany = (
        company: any,
    ): company is {
        id: number
        name: string
        isOfficeHotel: boolean
        userGroups: IdCardSubscriptionCompanyUserGroup[]
    } => {
        return (
            typeof company.id === "number" &&
            typeof company.name === "string" &&
            "userGroups" in company &&
            Array.isArray(company.userGroups) &&
            "isOfficeHotel" in company &&
            company.isOfficeHotel
        )
    }

    const isStandardCompany = (
        company: any,
    ): company is { id: number; name: string; userGroups: IdCardSubscriptionCompanyUserGroup[] } => {
        return (
            typeof company.id === "number" &&
            typeof company.name === "string" &&
            "userGroups" in company &&
            Array.isArray(company.userGroups)
        )
    }

    const isSingleGroupCompany = (
        company: any,
    ): company is { id: number; name: string; userGroup: IdCardSubscriptionCompanyUserGroup } => {
        return (
            typeof company.id === "number" &&
            typeof company.name === "string" &&
            "userGroup" in company &&
            !("userGroups" in company)
        )
    }
    return companies.flatMap<TransformedCompany>((company) => {
        if (isOfficeHotelCompany(company) && company.userGroups.length) {
            return company.userGroups.map((group) => ({
                id: `group-${company.id}-${group.id}`,
                displayName: `${company.name} - ${group.name}`,
                isGroup: true as const,
                companyId: company.id,
                userGroupId: group.id,
            }))
        }

        if (isStandardCompany(company)) {
            return [
                {
                    id: `company-${company.id}`,
                    displayName: company.name,
                    isGroup: false as const,
                    companyId: company.id,
                    userGroups: company.userGroups.map((group) => ({
                        id: group.id,
                        name: group.name,
                        displayName: group.displayName ?? group.name,
                    })),
                    userGroup: undefined,
                },
            ]
        }

        if (isSingleGroupCompany(company)) {
            return [
                {
                    id: `company-${company.id}`,
                    displayName: company.name,
                    isGroup: false as const,
                    companyId: company.id,
                    userGroup: company.userGroup,
                    userGroups: [],
                },
            ]
        }

        return []
    })
}

export const prepareInitialValues = (companies: TransformedCompany[]): IdCardSignupFormValues => {
    const userGroupForSingleCompany = (company: TransformedCompany) => {
        if (!company.isGroup && company?.userGroup) {
            return company?.userGroup.id.toString()
        } else if (!company.isGroup && company.userGroups?.length === 1) {
            return company?.userGroups && company?.userGroups[0].id.toString()
        } else {
            return null
        }
    }

    return {
        displayName: "",
        mobileNumber: "",
        subscriptionId: null,
        ...(companies.length === 1
            ? {
                  companyId: companies[0].id,
                  userGroupId: userGroupForSingleCompany(companies[0]),
              }
            : { companyId: null, userGroupId: null }),
    }
}
